export default __webpack_public_path__ + "static/media/coresanscr75-webfont.6c3dc91b.woff2";